import Layout from '@/layout/index.vue'

export default [
  {
    path: '/statistics',
    name: 'statistics',
    component: Layout,
    meta: {
      title: '流量统计',
      icon: 'iconfont icon-icon-shijianxuanze',
    },
    redirect: '/statistics/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/statistics/index.vue'),
        meta: {
          level: 0,
        },
      },
    ],
  },
]
